import clsx from 'clsx';
import type React from 'react';
import { useRecoilValue } from 'recoil';

import type { BlockHighlightProps } from '../../../../../Components';
import { useNavigationState } from '../../../../../navigation';
import { isCommentNodeHoveredSelector } from '../../../../../state';

/**
 * Highlight the current block when hovering comments.
 */
export function BlockCommentHalo(props: BlockHighlightProps): React.ReactElement | null {
    const { nodeKey } = props;
    const { screen } = useNavigationState();

    /** Node highlighted when hovering comment button */
    const nodeIsHovered = useRecoilValue(isCommentNodeHoveredSelector(nodeKey));
    /** Node highlighted to post new comment  */
    const openedNode =
        screen.type === 'space' &&
        screen.sideSheet?.type === 'comments' &&
        !screen.sideSheet?.tableCell
            ? screen.sideSheet.node
            : null;
    const nodeIsOpened = openedNode === nodeKey;

    if (nodeIsHovered || nodeIsOpened) {
        return (
            <span
                className={clsx(
                    '-z-[1] -m-2 pointer-events-none absolute flex size-[calc(100%+1rem)] select-none border-[var(--sp-color-comments-block-border)] border-solid',
                    nodeIsOpened || nodeIsHovered
                        ? 'bg-[var(--sp-color-comments-block-bg)]'
                        : 'bg-transparent',
                    nodeIsOpened ? 'border-b-2' : 'border-b-0'
                )}
                contentEditable={false}
            />
        );
    }

    return null;
}
